import { Grid, makeStyles, Typography } from "@material-ui/core";
import React from "react";
import {
  GameList,
  GamesListType,
  GooglePlayStoreLink,
} from "../../Constants/Data";
import GameCardView from "../GamesCards/GameCardView";
import PageTitle from "../PageTitle/PageTitle";

const style = makeStyles({
  Grid: {
    marginBottom: 40,
  },
  ParentGrid: {
    width: "700px",
    // eslint-disable-next-line no-useless-computed-key
    ["@media (max-width:600px)"]: {
      width: "350px",
    },
  },
  ParentGridContainer: {
    padding: 30,
  },
  AllGamesText: {
    color: "white",
    cursor: "pointer",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  FooterText: {
    color: "white !important",
  },
  FooterGrid: {
    width: "100%",
    a : {
      color: "white !important",
    }
  },
});
const HomePage = () => {
  const classes = style();

  return (
    <>
      <Grid
        container
        className={classes.ParentGridContainer}
        justify={"center"}
      >
        <PageTitle />
        <Grid container spacing={6} className={classes.ParentGrid}>
          {GameList.map((item: GamesListType) => (
            <Grid key={item.id} item xs={12} sm={6}>
              <GameCardView gameInfo={item} />
            </Grid>
          ))}
        </Grid>
      </Grid>
      <Grid container className={classes.Grid}>
        <Grid item xs={12}>
          <Typography
            align={"center"}
            variant={"h4"}
            className={classes.AllGamesText}
            onClick={() => window.open(GooglePlayStoreLink, "_blank")}
          >
            Our games
          </Typography>
        </Grid>
      </Grid>
      <Grid container justify={"center"} className={classes.Grid}>
        <Grid container className={classes.FooterGrid}>
          <Grid item xs={12} sm={4} md={4}>
            <Typography align={"center"} className={classes.FooterText}>
              info@yaolabs.io
            </Typography>
          </Grid>
          <Grid item xs={12} sm={4} md={4}>
            <Typography align={"center"} className={classes.FooterText}>
              &#xa9;2021 by Yao Labs
            </Typography>
          </Grid>
          <Grid item xs={12} sm={4} md={4}>
            <Typography align={"center"} className={classes.FooterText}>
              <a href={"https://docs.google.com/document/d/1jSdbYyuSNlMmIS06H3n8_kA7bj0DOJFfbLjorWbQz_8"}>Terms of use & privacy</a>
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default HomePage;
